import {
  anoDeServico,
  mesesDoAnoDeServico,
  relataHoras,
  type Mes,
  type TipoDePerfil,
} from '@sheafyield/dominio';
import { useState } from 'react';

import { Botao } from '../ds/Botao.js';
import { Linha } from '../ds/Linha.js';
import { Selecao } from '../ds/Selecao.js';
import { Vazio } from '../ds/Vazio.js';

export interface PropsHistorico {
  meses: readonly Mes[];
  selecionado: { ano: number; mes: number };
  aoSelecionar: (ano: number, mes: number) => void;
  tipoDePerfil: TipoDePerfil;
  atual?: { ano: number; mes: number };
}

const rotulo = (ano: number, mes: number) =>
  new Intl.DateTimeFormat('pt-BR', { month: 'long' }).format(
    new Date(ano, mes - 1, 1),
  );

export function Historico({
  meses,
  selecionado,
  aoSelecionar,
  tipoDePerfil,
  atual = selecionado,
}: PropsHistorico) {
  const [ano, setAno] = useState(() =>
    anoDeServico(selecionado.ano, selecionado.mes),
  );
  const [periodoLido, setPeriodoLido] = useState(selecionado);
  if (
    periodoLido.ano !== selecionado.ano ||
    periodoLido.mes !== selecionado.mes
  ) {
    setPeriodoLido(selecionado);
    setAno(anoDeServico(selecionado.ano, selecionado.mes));
  }
  const anos = Array.from(
    new Set([
      ...meses.map((item) => anoDeServico(item.ano, item.mes)),
      anoDeServico(atual.ano, atual.mes),
    ]),
  ).sort((a, b) => b - a);
  const noAno = mesesDoAnoDeServico(ano);
  const porPeriodo = new Map(
    meses.map((item) => [`${item.ano}-${item.mes}`, item]),
  );
  return (
    <section className="relatorio__historico" aria-label="Histórico">
      <h2>Histórico</h2>
      <p className="relatorio__legenda-ano">Ano de serviço</p>
      <Selecao
        rotulo="Ano de serviço"
        valor={String(ano)}
        opcoes={anos.map((valor) => ({
          valor: String(valor),
          rotulo: String(valor),
        }))}
        aoMudar={(valor) => setAno(Number(valor))}
      />
      <Botao
        variante="texto"
        onClick={() => {
          setAno(anoDeServico(atual.ano, atual.mes));
          aoSelecionar(atual.ano, atual.mes);
        }}
      >
        Voltar ao mês atual
      </Botao>
      {meses.length === 0 ? (
        <Vazio titulo="Nenhum mês neste ano de serviço." />
      ) : null}
      <ul>
        {noAno.map(({ ano: anoDoMes, mes }) => {
          const item = porPeriodo.get(`${anoDoMes}-${mes}`);
          const futuro =
            anoDoMes > atual.ano || (anoDoMes === atual.ano && mes > atual.mes);
          return (
            <Linha
              key={`${anoDoMes}-${mes}`}
              titulo={rotulo(anoDoMes, mes)}
              detalhe={
                futuro
                  ? 'Mês futuro'
                  : item
                    ? `${relataHoras(tipoDePerfil) ? `${formatar(item.horas_minutos)} · ` : ''}${item.estudos} estudos`
                    : 'Sem atividade registrada'
              }
              meta={
                item?.enviado_em
                  ? `Marcado como enviado em ${new Date(item.enviado_em).toLocaleDateString('pt-BR')}`
                  : undefined
              }
              aoTocar={() => aoSelecionar(anoDoMes, mes)}
            />
          );
        })}
      </ul>
    </section>
  );
}

function formatar(minutos: number): string {
  const horas = Math.floor(minutos / 60);
  return `${horas}h${String(minutos % 60).padStart(2, '0')}`;
}
